/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { LotType } from '../../models/lot-type';
import { SearchLotResultDto } from '../../models/search-lot-result-dto';

export interface SearchForLotByPlan$Params {
  plan: string;
  lot?: string;
  type?: LotType;
}

export function searchForLotByPlan(
  http: HttpClient,
  rootUrl: string,
  params: SearchForLotByPlan$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SearchLotResultDto>> {
  const rb = new RequestBuilder(rootUrl, searchForLotByPlan.PATH, 'get');
  if (params) {
    rb.query('plan', params.plan, {});
    rb.query('lot', params.lot, {});
    rb.query('type', params.type, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SearchLotResultDto>;
      }),
    );
}

searchForLotByPlan.PATH = '/search/lot/by_plan';
